export default __webpack_public_path__ + "static/media/customize-chatbot.3b9b975d.svg";